import {
  FrameworkRefsComponent,
  MitreAttacksComponent,
  MitreWeaknessesComponent,
  ThreatActorsComponent,
} from '@/sections/threats/drawer/components';
import type {
  EnrichedVulnerability,
  FrameworkRef,
} from '@/sections/threats/types';

interface FrameworksTabProps {
  threatIntel?: EnrichedVulnerability;
  frameworkRefs?: FrameworkRef[];
}

export function MitreTab({
  threatIntel,
  frameworkRefs = [],
}: FrameworksTabProps) {
  return (
    <>
      <ThreatActorsComponent threatIntel={threatIntel} />
      <MitreAttacksComponent threatIntel={threatIntel} />
      <MitreWeaknessesComponent threatIntel={threatIntel} />
      <FrameworkRefsComponent frameworkRefs={frameworkRefs} />
    </>
  );
}
